import { Box } from '@chakra-ui/react';
import { useAnalytics } from 'hooks/useAnalytics';
import { useAuthPopup } from 'hooks/useAuthPopup';
import { GA_CLICK_EVENT_NAMES } from 'lib/firebase/ga_events';
import React from 'react';
import QuestionHowCanWeHelp from './QuestionHowCanWeHelp';

export default function OnboardingsSmall() {
  const { onOpenOnboardingModal } = useAuthPopup();
  const { trackGAClickEvent } = useAnalytics();

  const handleClickOption = (value: string) => {
    onOpenOnboardingModal(value);
    trackGAClickEvent({
      click_event_name: GA_CLICK_EVENT_NAMES.ONBOARDING_OPTION_CLICKED,
      question_type: 'reason',
      question_part: 1,
      option_name: value
    });
  };

  return (
    <Box height="100%" width="100%" className="onboarding-container">
      <QuestionHowCanWeHelp onOptionSelect={handleClickOption} />
    </Box>
  );
}
